@if (!showImportantModalScreen) {
  <div class="screen-content">
    @if (step === 1) {
      <div class="step step-one">
        <div class="step__description description">
          <div class="step__logo-wrapper">
            <img alt="" class="step__logo-img" src="{{ welcomeModalData?.logo }}" />
          </div>
          <h4 class="step__subtitle">Welcome to your</h4>
          <h1
            [ngStyle]="{ color: '#' + welcomeModalData?.primaryColor }"
            class="step__title-logo"
            [innerHTML]="modalTemplateData[0]?.title ?? 'Mortgage Monitor'"></h1>
          <div class="step__text">
            {{ modalTemplateData[0]?.description ?? "" }}
          </div>
        </div>
      </div>
    }
    @for (item of modalTemplateData.slice(1); track item; let i = $index) {
      @if (step === i + 2) {
        <ng-container
          *ngTemplateOutlet="
            stepTemplate;
            context: {
              logo: welcomeModalData.logo,
              sectionTitle: item.title,
              sectionDescription: item.description,
              backgroundImgPath: item.imgDesktop,
            }
          " />
      }
    }
    <div class="screen-content__bottom-section">
      <div class="screen-content__buttons-wrapper">
        <button
          pButton
          class="p-button p-button-company-color icon-only screen-content__button-back"
          [disabled]="step === 1"
          (click)="back()">
          <shared-icon icon="arrow-left" height="0.6rem" width="0.6rem" />
        </button>
        <div class="screen-content__step-counter">
          <span
            [ngStyle]="{ color: '#' + welcomeModalData?.primaryColor }"
            class="screen-content__current-step"
            >{{ step }}</span
          >
          <div class="screen-content__progress-bar">
            <div
              [ngStyle]="{
                width: progressRatio * step + '%',
                'background-color': '#' + welcomeModalData?.primaryColor,
              }"
              class="screen-content__progress-bar-inner"></div>
          </div>
          <span class="screen-content__total-steps">{{ maxStep }}</span>
        </div>
        <button
          pButton
          class="p-button p-button-company-color icon-only screen-content__button-next"
          [disabled]="step === maxStep"
          (click)="next()">
          <shared-icon icon="arrow-right" height="0.6rem" width="0.6rem" />
        </button>
      </div>
      @if (step < maxStep) {
        <button
          pButton
          class="p-button p-button-grey screen-content__button-skip"
          (click)="hideTutorialModal()">
          @if (
            welcomeModalData.creationMethod ===
            ENUM_ClientUserCreationMethod.CLIENT_USER_CREATION_METHOD_SIGN_UP_LANDLORD
          ) {
            Skip and start tracking your portfolio
          } @else {
            Skip and start with Mortgage Monitor
          }
          <shared-icon class="pl-1" icon="double-arrow-right" height="0.6rem" width="0.6rem" />
        </button>
      }
      @if (step === maxStep) {
        <button
          pButton
          class="p-button p-button-company-color screen-content__button-skip"
          (click)="hideTutorialModal()">
          @if (
            welcomeModalData.creationMethod ===
            ENUM_ClientUserCreationMethod.CLIENT_USER_CREATION_METHOD_SIGN_UP_LANDLORD
          ) {
            Start tracking your portfolio
          } @else {
            Start with Mortgage Monitor
          }
          <shared-icon class="pl-1" icon="double-arrow-right" height="0.6rem" width="0.6rem" />
        </button>
      }
    </div>
  </div>
}

@if (showImportantModalScreen) {
  <div class="important-modal">
    <div class="important-modal__content">
      <shared-icon
        (click)="finishTutorial()"
        class="important-modal__icon pointer"
        height="1rem"
        icon="cross"
        fill="white"
        width="1rem" />
      <h3 class="important-modal__title">Important</h3>
      <div class="important-modal__description">
        Please bookmark your Dashboard and return to it to update your details if your situation
        changes. The more accurate and up to date this data is, the better our search results will
        be.
      </div>
    </div>
  </div>
}

<ng-template
  #stepTemplate
  let-backgroundImgPath="backgroundImgPath"
  let-logo="logo"
  let-sectionDescription="sectionDescription"
  let-sectionTitle="sectionTitle">
  <div [ngStyle]="{ 'background-image': 'url(' + backgroundImgPath + ')' }" class="step">
    <div class="step__description description">
      <div class="step__logo-wrapper">
        <img [src]="logo" alt="" class="step__logo-img" />
      </div>
      <div class="step__description-content">
        <h1 [innerHTML]="sectionTitle" class="step__title"></h1>
        <div class="step__text">
          {{ sectionDescription }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
